import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CommonRoutingModule } from './page/common/common-routing.module';
import { PartnerRoutingModule } from './page/partner/partner-routing.module';
import { WorkerRoutingModule } from './page/worker/worker-routing.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }),
    CommonRoutingModule,
    PartnerRoutingModule,
    WorkerRoutingModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
